import fetcher from 'api/fetcher';
import axios, { AxiosError } from 'axios';
import { push } from 'connected-react-router';
import { CAMPAIGN_CREATION_WIZARD_HISTORY_STATE } from 'utils/campaignCreationWizardFlow/campaignCreationWizardFlow';
import { CREATE_MENU_PAGE_ROUTE } from 'utils/constants/app';
import { MagritteNotificationName } from 'utils/constants/notification';

import vrPackageFormFormSubmit, {
    Preset as PresetAnalytics,
} from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/vr_package/vr_package_form_form_submit';

import { goToPromotionTypeStep } from 'store/models/campaignCreationWizard';
import { setMainMenuVacancy } from 'store/models/mainMenu';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

interface RequestParams {
    phone: string;
    responses: number;
    budget: number;
    areas: number[];
    requirements: string;
}

export const fetchVrRequest = (
    params: RequestParams,
    handleCloseModal: () => void,
    abortSignal: AbortSignal
): AppThunkAction<Promise<void>> => {
    return (dispatch, getState) => {
        const { preset, vacancy } = getState().vrCampaign;
        const vacancyId = vacancy.vacancyId ?? 0;
        const analyticsParams = {
            responsesCount: params.responses,
            amount: params.budget,
            preset: preset as PresetAnalytics,
            geoCount: params.areas.length,
            geoIds: params.areas.join(','),
            hasHiddenRequirements: params.requirements.length > 0,
            requirementsLength: params.requirements.length,
            vacancyId,
        };

        return fetcher
            .post('/api/v1/crm/activity/vr', { ...params, vacancyId }, { signal: abortSignal })
            .then(() => {
                dispatch(addMagritteNotification(MagritteNotificationName.VrCampaignRequestSuccess));
                vrPackageFormFormSubmit({ ...analyticsParams, errors: null });
                handleCloseModal();

                if (vacancy.vacancyId) {
                    dispatch(
                        setMainMenuVacancy({
                            vacancyId: vacancy.vacancyId,
                            vacancyName: vacancy.vacancyName ?? undefined,
                        })
                    );
                    dispatch(
                        goToPromotionTypeStep({
                            vacancyId: vacancy.vacancyId,
                            vacancyName: vacancy.vacancyName ?? undefined,
                        })
                    );
                }

                dispatch(push(CREATE_MENU_PAGE_ROUTE, CAMPAIGN_CREATION_WIZARD_HISTORY_STATE));
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error) || abortSignal.aborted) {
                    return;
                }

                dispatch(addMagritteNotification(MagritteNotificationName.SomethingWentWrong));
                vrPackageFormFormSubmit({
                    ...analyticsParams,
                    errors: JSON.stringify(error.response?.data ?? error),
                });
            });
    };
};
